import React from "react"
import styled from "styled-components"

export default function Cart() {
  return (
    <Wrapper>
      <div className="content">
        <h4>Chaica, Carretera Austral, Región de los Lagos</h4>
        <hr className="hr" />
        <p>
          Somos una pequeña cabaña en el Sur de Chile, brindamos hospedaje +
          tinaja a 20 minutos de Puerto Montt.
        </p>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.article`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: var(--grey-50);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 30px 10px;

  .content {
    width: 300px;
    padding: 1rem 1rem 1rem;
    h4 {
      font-weight: bold;
    }
  }

  @media screen and (min-width: 768px) {
    top: 50%;
    left: 35%;

    .content {
      width: 450px;
    }
  }

  @media screen and (min-width: 992px) {
    padding: 40px 40px 20px;
    left: 25%;
    .content {
      width: 600px;
      h4 {
        font-size: 2rem;
      }
      p {
        font-size: 1.2rem;
      }
    }
    .section-center {
      width: 95vw;
    }
  }
`
